
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { sharedState } from '../../framework/state';
import { ValidationProvider } from 'vee-validate';
import { getFieldNameFromVModelProperty } from '../../framework/util/component_util';

@Component({
    components: { ValidationProvider },
})
export default class MonthsField extends Vue {
    @Prop(String) readonly name!: string;
    @Prop(Number) readonly value!: number;
    @Prop(Boolean) readonly readonly!: string;
    @Prop(Boolean) readonly required!: boolean;
    @Prop(Boolean) readonly horizontal!: boolean;
    @Prop(Boolean) readonly disabled!: string;
    @Prop(Boolean) readonly hideLabel!: boolean;
    @Prop(Number) readonly width!: number;

    shared = sharedState;
    local = {
        value: undefined as number | undefined,
    };

    async mounted() {}

    @Watch('value')
    async modelValueChange(newValue: number) {
        this.local.value = newValue;
    }

    @Watch('local.value')
    async inputValueChange(newValue: string | null) {
        const numberValue =
            typeof newValue !== 'undefined' && newValue !== null && newValue.length > 0
                ? parseFloat(newValue)
                : undefined;
        if (typeof numberValue !== 'undefined') {
            this.$emit('input', numberValue);
        }
    }

    getFieldLabel(): string {
        if (this.hideLabel) {
            return '';
        } else {
            return `${this.$t('field.' + this.getFieldName())} [${this.$t('mm')}]`;
        }
    }

    getFieldName() {
        return getFieldNameFromVModelProperty(this);
    }
}
